import { Alert, Button, ButtonSwitch, Col, Row } from '@intech/web-ui';
import React, { useState } from 'react';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';

interface IProps {
  avancar: (PassoEspecifico?: number | null) => Promise<void>;
  voltar: (PassoEspecifico?: number | null) => Promise<void>;
}

export const Passo9: React.FC<IProps> = ({
  avancar,
  voltar
}) => {
  const [Checked, setChecked] = useState<boolean>(false);
  const [Erro, setErro] = useState<string>("");

  function handleAvancar() {
    setErro("");
    if (!Checked) {
      setErro("É necessário ler e aderir ao código de ética para prosseguir.");
      return;
    }
    avancar();
  }

  return (
    <>
      <span>
        {"Clique "}
        <a target={"_blank"} rel={"noopener noreferrer"} href={"./codigo_etica_conduta.pdf"}>{"aqui"}</a>
        {" para baixar o Código de Ética e Conduta da Faelce."}
      </span>

      <Row className={"mb-2"}>
        <Col>
          <ButtonSwitch
            activeType={"success"}
            inactiveType={"danger"}
            activeTitle={"Formalizo minha adesão aos termos do Código de Ética e Conduta da Faelce, aprovado por seu Conselho Deliberativo, através da Resolução CONDEL 024/2021, de 21/07/2021, comprometendo-me a respeitar, no que couber, os princípios e regras nele estabelecidos."}
            inactiveTitle={"Formalizo minha adesão aos termos do Código de Ética e Conduta da Faelce, aprovado por seu Conselho Deliberativo, através da Resolução CONDEL 024/2021, de 21/07/2021, comprometendo-me a respeitar, no que couber, os princípios e regras nele estabelecidos."}
            checked={Checked}
            onChange={() => setChecked(!Checked)}
          />
        </Col>
      </Row>

      <Alert type={'danger'}>{Erro}</Alert>

      <Row>
        <Col>
          <Button
            type={"secondary"}
            title={"Voltar"}
            icon={<FaAngleDoubleLeft />}
            onClick={voltar}
            loadingText={"Voltando..."}
            usesLoading
            block
            iconRight
          />
        </Col>

        <Col>
          <Button
            type={"primary"}
            title={"Continuar"}
            icon={<FaAngleDoubleRight />}
            onClick={handleAvancar}
            loadingText={"Continuando..."}
            usesLoading
            block
          />
        </Col>
      </Row>
    </>
  );
}
